import React, { useRef } from "react"

import styled from "styled-components"

import { useLocalization } from "@izettle/lingo-client"
import { spacing } from "@izettle/otto"

import { FieldError } from "./field-error"
import { getErrorListId } from "./helpers"

const ErrorContainer = styled.div`
  margin: ${spacing.xxSmall} ${spacing.small} ${spacing.none} ${spacing.small};
`

export type ErrorsList = Array<string | React.ReactNode[]>

export type ErrorsObject = {
  [key: string]: ErrorsList
}

type FieldErrorsProps = {
  id: string
  errorKeys: ErrorsList
}

export const findParentWithClassName = (
  element: HTMLElement,
  className: string,
): HTMLElement | null => {
  if (element.classList.contains(className)) {
    return element
  }

  if (element.parentElement) {
    return findParentWithClassName(element.parentElement, className)
  }

  return null
}

export const FieldErrors: React.FC<FieldErrorsProps> = ({ id, errorKeys }) => {
  const errorRef = useRef<HTMLDivElement>(null)
  const { text } = useLocalization()

  if (errorKeys.length === 0) {
    return null
  }

  return (
    <ErrorContainer id={getErrorListId(id)} ref={errorRef}>
      {errorKeys.map((errorKey) => {
        return (
          <FieldError key={errorKey?.toString()}>
            {typeof errorKey === "string" ? text(errorKey) : errorKey}
          </FieldError>
        )
      })}
    </ErrorContainer>
  )
}
